module.exports = __webpack_public_path__ + "12d25c75161568a5a37e35815880572f.png";